"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgStatusInfo = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props),
    React.createElement("path", { fill: "#6B9FCA", fillRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.005-8.8c-.437 0-.8.363-.8.8v3.2c-.01.437.352.8.8.8a.79.79 0 0 0 .79-.8V8c0-.437-.352-.8-.79-.8m-.298-.864c.085.043.17.053.256.053q.007 0 .016.006.007.004.016.005.019-.001.035-.007l.018-.004a.6.6 0 0 0 .192-.042c.544-.118.96-.576.96-1.152C9.2 4.533 8.667 4 8.005 4 7.344 4 6.8 4.533 6.8 5.195c0 .565.395 1.013.907 1.141", clipRule: "evenodd" })));
exports.default = SvgStatusInfo;
